function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgSles(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M83.647 43.179a2.708 2.708 0 100-5.416 2.708 2.708 0 000 5.416zm-.125-4.619a1.75 1.75 0 110 3.5 1.75 1.75 0 010-3.5z"
  }), React.createElement("path", {
    d: "M74.355 46.096s-1.833-2 .75-1.75 4.312 2.654 9 2.583c2.027-.031 8.727-2.25 8.727-2.25l-.343-1.474s-2.149-6.863-8.966-8.123c-1.677-.31-3.252.763-3.252.763s-14-5.807-19.083-6.917c-5.083-1.11-19.417-3-34.75 3.75C11.105 39.429 7.323 46.872 6.573 47.372s-6.953 11.874-.5 17.417c13.616 8.973 12.167-2.667 12.167-2.667s-1.468-4.693-3.384-4.943c-1.917-.25-5.75-.167-5.25 2.333s1.5 3.75 2.083 3.25c.583-.5.333-1.417.333-1.417l-.833-.833s-.083-1.667 1.583-1.25c1.667.417 2.083 4.583.583 4.75-1.5.167-5.667 1.5-5.667-4.417.25-4.833 3.333-4.75 4.333-4.667s3.167-5.5 8.417-4.833c5.25.667 6.5 1.833 6.917 5 .417 3.167-.417 8.917 2.583 8.833s1.75-3.888 1.75-3.888l.417-4.945s1.75-3.667 4.5-.167c-.083 3.667.083 7.667.083 7.667s2.167 2.833 3.5-.083c.25-2.083.917-6.917.917-6.917s0-2.25 2.667-1.917 7.583 1.25 12.917.25c1.976-.3 1.167.583 1.917 1.833s1.917 7 1.917 7 3 2.75 3.25-.417c-.417-3.25-.917-8-.917-8s.167-2.667 2.417-.917c2.083 2.167 3.667 9.167 3.667 9.167s3 2.75 3.25-.75c-.24-2.431-1.5-3.417-1.167-5.167 0 0-.25-2.333 3.167-2.417.499-.018.167-.583-.667-1-.833-.417-5.583-3.833-5.583-3.833s-1.5-1.799.75-1.649c2.25.149 2.804 2.072 4.333 3.066 1.793 1.166 5.333 4.75 11.583 2.667s8.227-6.917 8.227-6.917-5.393 1.78-7.227 1.833c-5.668.167-11.251-2.331-11.251-2.331zm9.209-9.75a4.208 4.208 0 110 8.416 4.208 4.208 0 010-8.416z"
  }), React.createElement("circle", {
    cx: 83.524,
    cy: 40.28,
    r: 0.873
  }));
}

SvgSles.clsName = 'icon-www__sles';
SvgSles.remarkName = 'unknown';
export default SvgSles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Sles.js
// module id = 2436
// module chunks = 17 18